import React from 'react'

export default function MonthlySalesInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        .ms-report-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;

          /*
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          */
        }

        .ms-report-wrapper {
          flex: 1;
          /*display: flex;*/
          width: 100%;
          /*background-color: yellow;*/
          /*box-sizing: border-box;*/
        }

        #ms-left {
          flex: 1;
          display: flex;
          /*padding: 10px;*/
        }
        .ms-report-table {
          border-spacing: 0;
          font-size: 1rem;
          width: 100%;
          border: solid 0.5px lightgrey;
        }

        .ms-report-table td { padding: 5px 10px; }
        .ms-report-table th { padding: 10px 10px; }

        .striped tbody:nth-child(even) { background-color: #F7FFF7; }
        .ms-report-table thead { background-color: #A7ADB8; }
        .ms-report-table td { text-align: right; }
        .ms-report-table .month { text-align: left; font-weight: bold; }
        .ms-report-table .total { background-color: lightblue; font-weight: bold; }

        .ms-report-table th:nth-child(1), .inventory-table td:nth-child(1) { width: 30%; }
        .ms-report-table th:nth-child(2), .inventory-table td:nth-child(2) { width: 20%; }
        .ms-report-table th:nth-child(3), .inventory-table td:nth-child(3) { width: 20%; }
        .ms-report-table th:nth-child(4), .inventory-table td:nth-child(4) { width: 20%; }

        #ms-right {
          /*flex: 1;*/
          display: flex;
          box-sizing: border-box;
        }
        #quarterly-sales-data {
          /*flex: 1;*/
          width: 30%;
          padding: 20px;
          font-size: 1.2rem;
        }
        #quarterly-sales-data .row {
          display: flex;
          justify-contents: center
        }
        #quarterly-sales-data .row.total {
          font-weight: bold;
          border-top: solid 0.5px black;
        }

        #quarterly-sales-data .label { flex: 3; }
        #quarterly-sales-data .data { text-align: right; flex: 1; }

        .ms-report-chart {
          /*flex: 2;*/
          display: flex;
          width: 470px;
          margin: auto;
          /*height: 200px;*/
        }
      `}
      </style>
    </React.Fragment>
  )
}
